import { render, staticRenderFns } from "./ModalCadastrarUsuario.vue?vue&type=template&id=c2685c18"
import script from "./ModalCadastrarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastrarUsuario.vue?vue&type=style&index=0&id=c2685c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports